import { ArrowDownIcon, ArrowUpIcon } from "@heroicons/react/24/solid";
import clsx from "clsx";
import { MinusIcon } from "@heroicons/react/20/solid";
import { Delta } from "@/features/Metrics/Delta";

export function DeltaCellRenderer({ delta }: { delta?: Delta }) {
    const value = delta?.result.number;

    if (value === null || value === undefined || !Number.isFinite(value)) {
        return <span className={clsx("body-s subdued")}>-</span>;
    }

    const changePercent = value * 100 || 0;
    const isPositive = value > 0;
    const isNegative = value < 0;
    const isNeutral = value === 0;

    const formattedPercent = changePercent.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });

    return (
        <span
            className={clsx(
                "body-s hover:bg-hover flex cursor-pointer items-center gap-3",
            )}
        >
            {isPositive && (
                <ArrowUpIcon className="size-4 stroke-emerald-500" />
            )}
            {isNegative && <ArrowDownIcon className="size-4 stroke-red-500" />}
            {isNeutral && <MinusIcon className="size-4 stroke-gray-400" />}
            {formattedPercent}%
        </span>
    );
}
